import { useQuery } from '@tanstack/react-query'

import { caaMetricsInstance } from '../..'

export function getOperationalCAAMetricsPatientSemesterQueryKey({
  personaName,
  period,
  year
}: {
  personaName?: string
  period: number
  year: number
}) {
  return ['operationalCAAMetricsPatientSemester', { personaName, period, year }]
}

export function useOperationalCAAMetricsPatientSemesterQuery({
  personaName,
  period,
  year,
  enabled
}: {
  personaName?: string
  period: number
  year: number
  enabled?: boolean
}) {
  return useQuery({
    queryKey: getOperationalCAAMetricsPatientSemesterQueryKey({
      personaName,
      period,
      year
    }),
    queryFn: async () =>
      await caaMetricsInstance.getOperationalCAAMetricsPatientSemester({
        personaName,
        period,
        year
      }),
    enabled
  })
}
